import rmskincareAPI from '../utils/rmskincareAPI'

const appointmentApi = {
  getAppointment: async (date, endTime = null) => {
    let requestBody = {
      currentTime: date,
    }
    
    // 如果提供了endTime，则添加到请求体中
    if (endTime) {
      requestBody.endTime = endTime
    }
    
    let result = await rmskincareAPI.post('management/appointment/between', requestBody)
    return result.data
  },
  createAppointment: async (data, employeeId) => {
    let result = await rmskincareAPI.post(
      `management/appointment?employeeId=${employeeId}`,
      data
    )
    return result.data
  },

  modifyAppointment: async (data) => {
    let result = await rmskincareAPI.post(
      '/management/appointment/modify',
      data
    )
    return result.data
  },

  deleteAppointment: async (id) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/delete/${id}`
    )
    return result.data
  },

  cancelAppointment: async (id) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/cancel?id=${id}`
    )
    return result.data
  },

  findAppointmentById: async (id) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/findone/${id}`
    )
    return result.data
  },

  getRoster: async (isNext) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/getRoster/${isNext}`
    )
    return result.data
  },

  findAppointmentByCondition: async (data) => {
    let result = await rmskincareAPI.post(
      '/management/appointment/findAppointment/',
      data
    )
    return result.data
  },
  exchangeAppointment: async (data) => {
    let result = await rmskincareAPI.post(
      '/management/appointment/exchangeAppointment/',
      data
    )
    return null
  },
  getAppointmentByEmployee: async (data) => {
    let result = await rmskincareAPI.post(
      '/management/appointment/getAppointmentByEmployee',
      data
    )
    return result.data.data
  },

  /* Room */
  getRoomList: async () => {
    const status = 1
    let result = await rmskincareAPI.get(`/room/list?status=${status}`)
    return result.data.data
  },

  saveRoom: async (requestBody) => {
    let result = await rmskincareAPI.post('/room/save', requestBody)
    return result.data
  },

  updateMessage: async (appointmentId) => {
    let result = await rmskincareAPI.get(`/management/appointment/sendMsg?appointmentId=${appointmentId}`)
    return result.data
  },

  getAppointmentListByDate : async (currentDate) => {
    let result = await rmskincareAPI.get(`/management/appointment/rm/findByDate?currentDate=${currentDate}`)
    return result.data.data
  },

  // 标记官网预约为已联系（旧接口，保留兼容）
  markWebsiteAppointmentContacted: async (id, contacted, note = '') => {
    let result = await rmskincareAPI.post(
      `/management/appointment/markContacted/${id}`,
      { contacted, contactNote: note }
    )
    return result.data
  },

  // 更新官网预约处理状态
  // status: 'CONTACTED' | 'NEED_FOLLOW' | 'COMPLETED'
  // payload for COMPLETED must include: { beauticianId, confirmedStart, confirmedEnd }
  updateWebsiteAppointmentStatus: async (id, status, payload = {}) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/website/updateStatus/${id}`,
      { status, ...payload }
    )
    return result.data
  },

  // 记录账户打开官网预约的行为
  logWebsiteAppointmentView: async (id) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/website/logView/${id}`
    )
    return result.data
  },

  // 获取官网预约的操作日志
  getWebsiteAppointmentLogs: async (id) => {
    let result = await rmskincareAPI.get(
      `/management/appointment/website/logs/${id}`
    )
    return result.data.data
  },

  // 检查员工在指定时间段是否有预约冲突（按上午/下午时间段检查，跨门店）
  checkEmployeePeriodConflict: async (employeeId, startTime, endTime, currentStoreId, appointmentId = null) => {
    let requestBody = {
      employeeId: employeeId,
      startTime: startTime,
      endTime: endTime,
      currentStoreId: currentStoreId, // 当前预约的门店ID
      appointmentId: appointmentId // 编辑时排除当前预约
    }
    let result = await rmskincareAPI.post(
      '/management/appointment/checkPeriodConflict',
      requestBody
    )
    return result.data
  },

  // ── Waitlist APIs ─────────────────────────────────────────────────────────
  getWaitlist: async ({ date, storeId }) => {
    const params = new URLSearchParams({ date })
    if (storeId) params.append('storeId', storeId)
    const result = await rmskincareAPI.get(`/management/appointment/waitlist?${params}`)
    return result.data.data
  },

  getWaitlistCount: async ({ date, storeId }) => {
    const params = new URLSearchParams({ date })
    if (storeId) params.append('storeId', storeId)
    const result = await rmskincareAPI.get(`/management/appointment/waitlist/count?${params}`)
    return result.data.data // number
  },

  addToWaitlist: async (data) => {
    // data: { storeId, date, customerId?, firstName, lastName?, phoneNumber?,
    //         preferredTime?, preferredEmployeeId?, productIds?, note? }
    const result = await rmskincareAPI.post('/management/appointment/waitlist', data)
    return result.data
  },

  removeFromWaitlist: async (id) => {
    const result = await rmskincareAPI.post(`/management/appointment/waitlist/remove/${id}`)
    return result.data
  },

  updateWaitlistStatus: async (id, status, sendSms = false) => {
    const result = await rmskincareAPI.post(
      `/management/appointment/waitlist/status/${id}`,
      { status, sendSms }
    )
    return result.data
  },

  convertWaitlist: async (waitlistId, appointmentId) => {
    const result = await rmskincareAPI.post(
      `/management/appointment/waitlist/convert/${waitlistId}`,
      { appointmentId }
    )
    return result.data
  },

  // Refund the deposit for an appointment.
  // body: { amount?, expirationDate? }
  // Tries Void first (same-day). Falls back to Refund if settled (needs expirationDate).
  refundDeposit: async (appointmentId, body = {}) => {
    const result = await rmskincareAPI.post(
      `/management/appointment/${appointmentId}/refund-deposit`,
      body
    )
    return result.data
  },
}

export default appointmentApi
